import { Component, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import {Bonus} from '../../../../data/models/bonus.model';
import {TranslationService} from '../../../../core/services/translation.service';

import {MatButton} from "@angular/material/button";
import {FitImageDirective} from "../../../../core/directives/fit-image.directive";
import {NgOptimizedImage} from '@angular/common';
import {ImageService} from '../../../../core/services/image.service';

@Component({
  selector: 'app-bonus-detail',
  templateUrl: './bonus-detail.component.html',
  styleUrls: ['./bonus-detail.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    FitImageDirective,
    NgOptimizedImage
  ],
  standalone: true
})
export class BonusDetailComponent implements OnInit {
  private data = inject<{
    bonus: Bonus;
    showBonusPoints: boolean;
}>(MAT_DIALOG_DATA);
  translationService = inject(TranslationService);

  bonus: Bonus;
  showBonusPoints: boolean;
  imageService = inject(ImageService);

  constructor() {
    const data = this.data;

    this.bonus = data.bonus;
    this.showBonusPoints = data.showBonusPoints;
  }

  ngOnInit(): void {
    // this.translationService.loadTranslationGroup('order');
  }

}
